export default "__VITE_ASSET__fFEvUY4A__"